import { useMemo, useState } from 'react'

import { Filters } from './FilterControls'

import { CalendarCourtReporterEvent } from '@/apiClient'
import { toCalendarEvent } from '@/components/Calendar/Calendar'
import { useCalendarEvents } from '@/queries/calendar'
import * as urls from '@/queries/urls'
import { CalendarParams } from '@/queries/useCalendarParams'
import { normalize } from '@/utils/string'

export const filterCalendarEvents = (
  events: CalendarCourtReporterEvent[],
  filters: Filters,
): CalendarCourtReporterEvent[] =>
  events.filter(
    event =>
      filters.court_reporter_status_in.includes(event.court_reporter_status) &&
      normalize(event.name).includes(normalize(filters.search ?? '')) &&
      (!filters.timezone_in ||
        filters.timezone_in.length === 0 ||
        (!!event.timezone && filters.timezone_in.includes(event.timezone))),
  )

export const useFilteredCalendarEvents = ({
  courtReporterId,
  calendarParams,
  initialFilters,
}: {
  courtReporterId: string
  calendarParams: CalendarParams
  initialFilters: Filters
}) => {
  const [filters, setFilters] = useState<Filters>(initialFilters)

  const {
    events: allEvents,
    isFetching,
    refetch,
  } = useCalendarEvents<CalendarCourtReporterEvent>({
    url: urls.courtReporterEvents(courtReporterId),
    calendarParams,
  })

  const events = useMemo(
    () => filterCalendarEvents(allEvents, filters).map(toCalendarEvent),
    [allEvents, filters],
  )

  return {
    events,

    filters,
    setFilters,

    isFetching,
    refetch,
  }
}
